<div class="qb-w-100 qb-h-100 qb-main-create-new">
  <div class="qb-d-flex qb-fd-coloumn">
    <div>Milestone Configuration</div>
    <div class="qb-progress-container" *ngIf="type !== 'REWARDCONFIG'">
      <div
        class="qb-step-container cursor-pointer"
        (click)="changeSteps(1)"
        [ngClass]="{ active: step === 1, completed: completedSteps >= 1 }"
      >
        <span *ngIf="completedSteps < 1" class="qb-step-text">1</span>
        <span
          *ngIf="completedSteps >= 1"
          class="material-symbols-outlined qb-white-color"
          >done</span
        >
      </div>
      <div class="qb-line-after-step"></div>
      <div
        class="qb-step-container cursor-pointer"
        (click)="completedSteps >= 2  ? changeSteps(2) : null"
        [ngClass]="{ active: step === 2, completed: completedSteps >= 2 }"
      >
        <span *ngIf="completedSteps < 2" class="qb-step-text">2</span>
        <span
          *ngIf="completedSteps >= 2"
          class="material-symbols-outlined qb-white-color"
          >done</span
        >
      </div>
    </div>
  </div>
  <div class="qb-challenge-listing-container main-white-panel">
    <app-challenges-milestone-config
      [ngClass]="{
        'qb-creation-div-wrapper': true,
        'qb-d-flex': step === 1,
        'qb-d-none': step !== 1
      }"
      [configData]="milestoneData.configData.milestone"
      [isEdit]="isEdit"
      [status]="status"
      (milestoneConfigFunction)="milestoneConfig($event)"
    ></app-challenges-milestone-config>

    <app-challenges-reward-config
      [ngClass]="{
        'qb-creation-div-wrapper': true,
        'qb-d-flex': step === 2,
        'qb-d-none': step !== 2
      }"
      [rewardData]="milestoneData.configData.reward"
      [isEdit]="isEdit"
      [status]="status"
      (milestoneConfigFunction)="milestoneConfig($event)"
    ></app-challenges-reward-config>
  </div>
</div>
